import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from "material-react-table";
import AddCabraneModel from "../rawmaterialscabranes/AddCabraneModel";
import EditCabraneModel from "../rawmaterialscabranes/EditCabraneModel";
import Swal from "sweetalert2";

// Material UI Imports
import { MenuItem } from "@mui/material";

const RawMaterialCabranes = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [showmodelEdit, setshowmodelEdit] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  useEffect(() => {
        setPermission(FindModuleById(435)); 
      console.log(permission);


    axios
      .post(
        "/rawmaterials-cabranes/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.cabranes);
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const editItem = (id) => {
    setSelectedItemId(id);
    setshowmodelEdit(true);
  };
  const addForm = () => {
    console.log('add');
    setshowmodel(true);
  };

  const handleClose = () => {
    setshowmodel(false);
    setshowmodelEdit(false);
    setSelectedItemId(null);
  };

  const deleteItem = (item) => {
    Swal.fire({
      title: "Do you really want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "DELETE",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`/rawmaterials-cabranes/delete/${item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
              Swal.fire("Deleted!", "Your Record has been deleted.", "success");
              setTimeout(() => {
                window.location.href = "/rawmaterials-cabranes";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "phone_number",
      header: "Phone Number",
    },
    {
      accessorKey: "note",
      header: "Note",
    },
    {
      header: "Created By",
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : "",
    },
    {
      header: "Updated By",
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : "",
    },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={toggleMobileMenu} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Raw Materials Cabranes</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Raw Materials Cabranes</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.add == 1 && (
                  <button  onClick={() => addForm()} className="btn btn-primary">
                    <i className="fas fa-plus"></i>
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {permission && permission.list == 1 && (
                    <div className="table-responsive">
                      <MaterialReactTable
                        columns={columns}
                        data={data}
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                      
                        renderRowActionMenuItems={({ row }) => [
                        permission?.update == 1 && (
                          <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                            Edit
                          </MenuItem>
                        ),
                        permission?.delete == 1 && (
                          <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                            Delete
                          </MenuItem>
                        ),
                      ]}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <AddCabraneModel show={showmodel} handleClose={handleClose} />
        <EditCabraneModel itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} />
      </div>
    </div>
  );
}; 

export default RawMaterialCabranes;
